import { createFileRoute } from "@tanstack/react-router";

import { PrivacyPolicy } from "@/features/legal";

const PrivacyPage = () => (
  <main data-page="privacy" className="mx-auto w-full max-w-3xl px-6 py-8">
    <PrivacyPolicy />
  </main>
);

// Политика открывается без входа (`staticData.isPublic`): на неё ссылается страница входа.
export const Route = createFileRoute("/privacy")({
  staticData: { isPublic: true },
  component: PrivacyPage,
});
